/**
 * 专题课目录是否可看：只认整课授权 / 章课解锁 / 试学 / 课时免登录，不认购买开关。
 */
// 功能：目录章/课是否有观看权限；类型：新增；时间：2026-08-20 14:45:00
// 范围：catalogPriceOn / isWholeCourseOpen / isPeriodWatchable / isChapterWatchable
// 思路：purchaseSwitch、partNoLoginWatch 不得整棵标蓝；同时认 price 与 isPrice

/** 后端 boolean isPrice 可能序列化成 price 或 isPrice */
export const catalogPriceOn = (node) => {
  // 1. 空节点视为未解锁
  if (!node) {
    return false
  }
  // 2. 两种字段名都认，避免 Jackson 命名导致误判
  return !!(node.price || node.isPrice)
}

/** 课时未到解锁时间 */
export const isPeriodTimeLocked = (period) => {
  if (!period) {
    return false
  }
  if (period.unlockStatus === false) {
    return true
  }
  if (period.unlockTime) {
    const t = new Date(String(period.unlockTime).replace(/-/g, '/')).getTime()
    return !Number.isNaN(t) && t > Date.now()
  }
  return false
}

export const isWholeCourseOpen = (info) => {
  // 1. 整课已购或整课免登录才整课放开
  return !!(info?.buyStatus || info?.noLoginWatch)
}

export const isPeriodWatchable = (period, info) => {
  // 0. 未到解锁时间一律不可看（含试学）
  if (isPeriodTimeLocked(period)) {
    return false
  }
  // 1. 整课可看则课时都可看
  if (isWholeCourseOpen(info)) {
    return true
  }
  // 2. 课时已解锁或标了试学
  if (catalogPriceOn(period) || period?.tryLearn) {
    return true
  }
  // 3. 部分免登录只放开该课时自己的 noLoginWatch，不整棵变蓝
  if (info?.partNoLoginWatch && period?.noLoginWatch) {
    return true
  }
  return false
}

export const isChapterWatchable = (node, info) => {
  // 1. 整课可看则章可展开
  if (isWholeCourseOpen(info)) {
    return true
  }
  // 2. 整章解锁，或章下有课时直绑（后端会把章 price 置 true）
  if (catalogPriceOn(node)) {
    return true
  }
  // 3. 章内有可看课时（试学 / 课时免登录）才保持蓝色并允许展开
  const periods = node?.periodList || []
  if (periods.some((p) => isPeriodWatchable(p, info))) {
    return true
  }
  const children = node?.childrenList || []
  if (children.some((c) => isChapterWatchable(c, info))) {
    return true
  }
  return false
}
